import { render, staticRenderFns } from "./delete.vue?vue&type=template&id=0c252648&scoped=true"
import script from "./delete.vue?vue&type=script&lang=js"
export * from "./delete.vue?vue&type=script&lang=js"
import style0 from "./delete.vue?vue&type=style&index=0&id=0c252648&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c252648",
  null
  
)

export default component.exports